<template>
  <div class="floating-contact">
    <v-btn
      v-for="(item, index) in contactItems"
      :key="index"
      :href="item.href || undefined"
      :target="item.target || undefined"
      fab
      small
      class="contact-btn"
      :style="{ bottom: `${20 + index * 55}px` }"
      :color="item.color"
      elevation="6"
      @click="handleClick(item, $event)"
    >
      <v-icon
        v-if="item.isMdi"
        color="white"
      >
        {{ item.icon }}
      </v-icon>
      <i
        v-else
        :class="item.icon"
        :style="{
          color: item.name === 'telegram' ? '#0088cc' : 'transparent',
          fontSize: item.name === 'telegram' ? '42px' : '18px'
        }"
      />
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'FloatingContact',

    data: () => ({
      contactItems: [
        {
          name: 'whatsapp',
          href: 'https://api.whatsapp.com/send?phone=8613922289966',
          target: '_blank',
          icon: 'mdi-whatsapp',
          color: '#25D366',
          action: null,
          isMdi: true,
        },
        {
          name: 'telegram',
          href: 'https://t.me/TimYoox',
          target: '_blank',
          icon: 'fab fa-telegram',
          color: 'white',
          action: null,
          isMdi: false,
        },
        {
          name: 'top',
          href: null,
          target: null,
          icon: 'mdi-chevron-up',
          color: 'primary',
          action: null,
          isMdi: true,
        },
      ],
    }),

    methods: {
      handleClick(item, event) {
        // 如果按钮没有 href（比如 top 按钮），阻止默认行为
        if (!item.href) {
          event.preventDefault()
        }

        // 如果有自定义 action，执行它
        if (item.action) {
          item.action()
        } else if (item.name === 'top') {
          // 专门处理 top 按钮
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.floating-contact
  position: fixed
  right: 20px
  bottom: 20px
  z-index: 1000

.contact-btn
  position: fixed !important
  right: 20px
  transition: all 0.3s ease
  margin-bottom: 8px

  &:hover
    transform: scale(1.1)
    box-shadow: 0 8px 16px rgba(0,0,0,0.3) !important
</style>
